module.exports = __webpack_public_path__ + "static/media/Investor-LAUREN_BECKSTEDT_SOLO_V4_1646397720605.4c99f605.vtt";